/** Réseau & connaissances — experts, ressources, communautés */

/** Contact central pour sollicitations experts (Hostinger / WhatsApp). */
export const ISBD_SUPPORT_EMAIL = 'support@isbd360.com';
/** Expéditeur Auth (confirmation, mot de passe oublié) — SMTP Supabase. */
export const ISBD_NOREPLY_EMAIL = 'no-reply@isbd360.com';
export const ISBD_SUPPORT_WHATSAPP = '2250747736410';

export const NETWORK_EXPERT_CATEGORIES = [
  { key: 'all', label: 'Tous' },
  { key: 'designer', label: 'Designers' },
  { key: 'developpeur', label: 'Développeurs' },
  { key: 'manager', label: 'Managers' },
  { key: 'consultant', label: 'Consultants' },
  { key: 'mentor', label: 'Mentors' },
] as const;

export type NetworkExpertCategory = (typeof NETWORK_EXPERT_CATEGORIES)[number]['key'];

export type NetworkResourceKind = 'guide' | 'masterclass';

export interface NetworkExpert {
  id: string;
  full_name: string;
  role_title: string;
  handle: string;
  bio: string;
  category: string;
  specialties: string[];
  email: string;
  whatsapp: string;
  avatar_url: string | null;
  avatar_storage_path: string | null;
  is_online: boolean;
  is_published: boolean;
  sort_order: number;
  created_at?: string;
}

export interface NetworkResource {
  id: string;
  kind: NetworkResourceKind;
  title: string;
  description: string;
  file_name: string | null;
  storage_path: string | null;
  external_url: string | null;
  video_url: string | null;
  duration_label: string;
  is_published: boolean;
  sort_order: number;
  created_at?: string;
}

export function networkExpertInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0] ?? ''}${parts[1]![0] ?? ''}`.toUpperCase();
}

export function normalizeWhatsappNumber(raw: string): string {
  return raw.replace(/[^\d+]/g, '').replace(/^\+/, '');
}

export function whatsappLink(phone: string, text?: string): string {
  const n = normalizeWhatsappNumber(phone);
  const q = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${n}${q}`;
}

export function mailtoLink(email: string, subject?: string, body?: string): string {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  const q = params.toString();
  return `mailto:${email}${q ? `?${q}` : ''}`;
}
